import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Utils from '../utils/utils';
import { BrowserRouter as Router, Route, Link, Switch } from 'react-router-dom';

import Header from './commons/Header';
import Footer from './commons/Footer';
import NotFoundPage from '../components/commons/pages/NotFoundPage';
import LoginPage from './begin/login/LoginPage';
import SignupPage from './begin/signup/SignupPage';
import ForgotPasswordPage from './begin/forgot-password/ForgotPasswordPage';
import BirthdayWall from './begin/birthday-wall/BirthdayWall';
import HomePage from './home/HomePage';
import ProductListPage from './products/ProductListPage';
import NewArrivalsListPage from './products/NewArrivalsListPage';
import BestSellersListPage from './products/BestSellersListPage';
import SpecialsListPage from './products/SpecialsListPage';
import CartPage from './billing/cart/CartPage';
import ProductDetailsPage from './products/ProductDetailsPage';
import ReviewOrderPage from './billing/checkout/ReviewOrderPage';
import StripeResponsePage from './billing/checkout/StripeResponsePage';
import StripeFailureResponsePage from './billing/checkout/StripeFailureResponsePage';
import PlaceOrderPage from './billing/checkout/PlaceOrderPage';
import PlacePickerPage from './commons/PlacePicker';
import { EmailVerificationBanner } from './commons/Banners';
import SettingsPage from './settings/SettingsPage';
import OrderDetailsPage from './settings/orders/OrderDetailsPage';
import AboutPage from './about-us/AboutPage';
import ContactPage from './contact-us/ContactPage';
import TermsAndConditionsPage from './tos/TermsAndConditionsPage';
import ShippingTermsPage from './tos/ShippingTermsPage';
import RefundPolicyPage from './tos/RefundPolicyPage';
import PrivacyPolicyPage from './privacy-policy/PrivacyPolicyPage';
import ResetPasswordPage from './begin/reset-password/ResetPasswordPage';
import EmailVerficationPage from './begin/email-verification/EmailVerification';
import SearchResultsListPage from './products/SearchResultsListPage';
import OurStoryPage from './our-story/OurStoryPage';

import * as ProductsActions from '../actions/productsActions';
import ReactGA from 'react-ga';

ReactGA.initialize(GA_UA_ID);

class LogPageView extends React.PureComponent {
  componentDidMount() {
    ReactGA.set({ page: this.props.page });
    ReactGA.pageview(this.props.page);
  }
  render() {
    return null;
  }
}

const logPageView = () => {
  const page = window.location.pathname + window.location.search;
  return <LogPageView key={page} page={page} />;

};

class App extends React.Component {

  componentDidMount() {
    this.props.dispatch(ProductsActions.getDepartments())
  }

  render() {
    return (
      <div className="page-container">
        <Router>
          <div>
             <Route exact path="/privacy-policy-app" component={PrivacyPolicyPage} />
             <Route path="/" component={logPageView} />
             <EmailVerificationBanner />
             <Header />
            <div id="page-container">
               <Switch>
                <Route exact path="/" component={HomePage} />
                <Route exact path="/signin" component={LoginPage} />
                <Route exact path="/signup" component={SignupPage} />
                <Route exact path="/forgot-password" component={ForgotPasswordPage} />
                <Route exact path="/birthday-wall" component={BirthdayWall} />
                <Route exact path="/reset-password" component={ResetPasswordPage} />
                <Route exact path="/verify-email" component={EmailVerficationPage} />
                <Route exact path="/products/newarrivals" component={NewArrivalsListPage} />
                <Route exact path="/products/bestsellers" component={BestSellersListPage} />
                <Route exact path="/products/specials" component={SpecialsListPage} />
                <Route exact path="/products/specials/:special" component={SpecialsListPage} />
                <Route exact path="/products" component={ProductListPage} />
                <Route exact path="/search" component={SearchResultsListPage} />
                <Route path="/products/:productId" component={ProductDetailsPage} />
                <Route exact path="/cart" component={CartPage} />
                <Route exact path="/review-order" component={ReviewOrderPage} />
                <Route exact path="/stripe/success" component={StripeResponsePage} />
                <Route exact path="/stripe/cancel" component={StripeFailureResponsePage} />
                <Route exact path="/place-order" component={PlaceOrderPage} />
                <Route exact path="/place-picker" component={PlacePickerPage} />
                <Route exact path="/settings" component={SettingsPage} />
                <Route path="/orders/:orderId" component={OrderDetailsPage} />
                <Route exact path="/about" component={AboutPage} />
                <Route exact path="/contact" component={ContactPage} />
                <Route exact path="/tos" component={TermsAndConditionsPage} />
                <Route exact path="/shipping" component={TermsAndConditionsPage} />
                <Route exact path="/refunds" component={RefundPolicyPage} />
                <Route exact path="/privacy-policy" component={PrivacyPolicyPage} />
                <Route exact path="/our-story" component={OurStoryPage} />
                <Route component={NotFoundPage} />
              </Switch> 
             </div>
            <Footer />
          </div>
        </Router>
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.element
};

export default connect((state) => {
  return {
    loading: state.getIn(['products', 'loading']),
    error: state.getIn(['products', 'error'])
  };
})(App);



// WEBPACK FOOTER //
// ./src/containers/App.js